import React from 'react';
import PropTypes from 'prop-types';
import UserRolesList from '../UserRolesList';

import { Map } from 'immutable';

import Form from '../Form';

class CreateEventForm extends Form {
    static fieldsValidation = {
        name: [ 'required' ],
        email: [ ['required'], 'email' ],
        password: [],
        firstName: [ 'required' ],
        surname: [ 'required' ],
        jobTitle: [ 'required' ]
    };

    static propTypes = {};

    static defaultProps = {
        ...Form.defaultProps,
        roles: Map()
    };

    constructor(props, context) {

        const isCarousel = window.$store.getState().user.toJS().data.universe === 'carousel';

        CreateEventForm.fieldsValidation.password = isCarousel
            ? [ 'required', 'password-carousel', [ 'minLength' , 6] ]
            : [ 'required', [ 'minLength' , 6] ];

        super(props, context);
    }

    onSubmit(e, ...args) {
        e.preventDefault();
        super.onSubmit(e, ...args);
    }

    onRoleChange(roles) {
        let { data } = this.state;
        data.roles = roles.toJS();
        this.setState({ data });
    }

    renderForm() {
        return (
            <div>
                <div className="row">
                    <div className="col-6">
                        { this.getField(
                            <input
                                type="text"
                                label="Name"
                                key="name"
                                { ...this.getFieldParameters('name') }
                            />
                        ) }
                        { this.getField(
                            <input
                                type="text"
                                label="Email"
                                key="email"
                                { ...this.getFieldParameters('email') }
                            />
                        ) }
                        { this.getField(
                            <input
                                type="password"
                                label="Password"
                                key="password"
                                { ...this.getFieldParameters('password') }
                            />
                        ) }
                        { this.getField(
                            <input
                                type="text"
                                label="First name"
                                key="firstName"
                                { ...this.getFieldParameters('firstName') }
                            />
                        ) }
                        { this.getField(
                            <input
                                type="text"
                                label="Surname"
                                key="surname"
                                { ...this.getFieldParameters('surname') }
                            />
                        ) }
                        { this.getField(
                            <input
                                type="text"
                                label="Job title"
                                key="jobtitle"
                                { ...this.getFieldParameters('jobTitle') }
                            />
                        ) }
                    </div>
                    <div className="col-6">
                        <UserRolesList
                            onRoleChange={ this.onRoleChange.bind(this)}
                            roles={ this.props.roles }
                            editing
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <button type="submit" className="btn btn-primary">
                            Add user
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateEventForm;
